import { API_AUTH_URL } from '../utils/constants'

export interface UserProfile {
  _id: string
  name: string
  email: string
  phone: string
  usertype: string
  gender: string
  country: string
  state: string
  city: string
  companyId: string
  companyName: string
  isActive: boolean
  isDeleted: boolean
  createdAt: string
}

export const getUserProfile = async (userId: string): Promise<UserProfile> => {
  try {
    const token = localStorage.getItem('AUTH_TOKEN')
    if (!token) {
      throw new Error('No authentication token found')
    }

    const response = await fetch(`${API_AUTH_URL}/api/admin/${userId}`, {
      method: 'GET',
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${token}`
      }
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching user profile:', error)
    throw error
  }
}

export const updateUserProfile = async (userId: string, userData: Partial<UserProfile>): Promise<any> => {
  try {
    const token = localStorage.getItem('AUTH_TOKEN')
    if (!token) {
      throw new Error('No authentication token found')
    }

    const response = await fetch(`${API_AUTH_URL}/api/admin/${userId}`, {
      method: 'PUT',
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        _id: userId,
        ...userData
      })
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error updating user profile:', error)
    throw error
  }
}
